import { render, staticRenderFns } from "./createDemand.vue?vue&type=template&id=6b346e43&"
import script from "./createDemand.vue?vue&type=script&lang=js&"
export * from "./createDemand.vue?vue&type=script&lang=js&"
import style0 from "./createDemand.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports